// packages block
import React from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import { TableRow, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead } from "@material-ui/core";
// common block
import { useStyles } from "../../../../components/managementTable/styles";
// constants, theme, utils and api block
import { amountFormat } from "../../../../util/constants";

const useOwnStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  pending: {
    background: "#FDEAE1",
    color: "#F38149",
    padding: "5px 1em",
    borderRadius: "5px",
    textTransform: "capitalize",
  },
  due: {
    background: "#E8F39E",
    color: "#96B522",
    padding: "5px 1em",
    borderRadius: "5px",
    textTransform: "capitalize",
  },
});

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

export const AllInvoices = ({
  allInvoices,
  student,
  genrateInvoice = () => { },
  viewInvoice = () => { },
  editInvoice = () => { },
  deleteInvoice = () => { },
  editStudent = () => { },
}) => {
  const classes = useOwnStyles();
  const tableClasses = useStyles()
  return (
    <div className="invoice-table-box">
      <Box padding={2.5}>
        <Typography variant="h5">
          Previous Invoices
        </Typography>
      </Box>

      <div style={{ color: "black", fontWeight: "bold", flex: 1 }}>
        <TableContainer>
          <Table className={classes.table} aria-label="simple table">
            <TableHead className={tableClasses.thead}>
              <TableRow >
                <TableCell style={{ color: "white" }}>Invoice #</TableCell>
                <TableCell style={{ color: "white" }}>Fee Month</TableCell>
                <TableCell style={{ color: "white" }}>Due Date</TableCell>
                <TableCell style={{ color: "white" }}>Amount</TableCell>
                <TableCell style={{ color: "white" }}>Status</TableCell>
                <TableCell style={{ color: "white" }}></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {allInvoices.voucher &&
                //allInvoices.voucher.slice(1).map((invoice) => (
                allInvoices.voucher.map((invoice) => (
                  <TableRow key={invoice.id}>
                    <TableCell component="th" scope="row">
                      {invoice.invoiceId}
                    </TableCell>

                    <TableCell>
                      {moment(invoice.feeMonth).format("MM-YYYY")}
                    </TableCell>

                    <TableCell>
                      {moment(invoice.dueDate).format("DD/MM/YYYY")}
                    </TableCell>

                    <TableCell style={{ color: "#20808D" }}>
                      {amountFormat(invoice.amount + invoice.otherFee)}
                    </TableCell>

                    <TableCell>{invoice.status}</TableCell>
                    {/* <TableCell>
                      <div style={{ width: "37px" }}>
                        <ActionMenu
                          isView={true}
                          student={student}
                          isEditStudent={true}
                          handleEditStudent={editStudent}
                          isEditInvoice={true}
                          handleEditInvoice={editInvoice}
                          handleViewInvoice={viewInvoice}
                          handleDeleteInvoice={deleteInvoice}
                          isDelete={true}
                          tableFor="invoices"
                          selectedItem={invoice}
                          actionMenuName={[
                            "View",
                            "Edit Student",
                            "Edit Invoice",
                            "Delete",
                          ]}
                        />
                      </div>
                    </TableCell> */}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};
